import React, { useEffect } from 'react';
import { KVKK_TEXT } from './constants';

const KVKKModal = ({ isOpen, onClose, onAccept }) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity animate-fadeIn"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-auto transform transition-all animate-scaleIn">
          {/* Header */}
          <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-xl flex items-center justify-between">
            <h3 className="text-xl font-semibold text-gray-900">
              KVKK Aydınlatma Metni
            </h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className="px-6 py-6 max-h-[60vh] overflow-y-auto">
            <div className="prose prose-sm max-w-none">
              <pre className="whitespace-pre-wrap font-sans text-sm text-gray-700 leading-relaxed">
                {KVKK_TEXT}
              </pre>
            </div>
          </div>

          {/* Footer */}
          <div className="sticky bottom-0 bg-gray-50 px-6 py-4 rounded-b-xl border-t border-gray-200 flex flex-col md:flex-row gap-3">
            <button
              onClick={onClose}
              className="flex-1 py-3 px-6 rounded-lg font-medium text-gray-700 hover:bg-gray-100 transition-colors duration-200"
            >
              Kapat
            </button>
            <button
              onClick={onAccept}
              className="flex-[2] bg-primary text-white py-3 px-6 rounded-lg font-semibold hover:bg-primary-dark transition-colors duration-200 shadow-md transform active:scale-[0.98]"
            >
              Okudum, Onaylıyorum
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KVKKModal;
